import { SEVERITY } from "helpers/utils.js";
import {
  GET_INVOICE_NOTE,
  GET_INVOICE_NOTE_SUCCESS,
  GET_INVOICE_NOTE_FAIL,
  GET_INVOICE_NOTE_BY_ID_SUCCESS,
  ADD_NEW_INVOICE_NOTE,
  ADD_NEW_INVOICE_NOTE_SUCCESS,
  UPDATE_INVOICE_NOTE,
  UPDATE_INVOICE_NOTE_SUCCESS,
  DELETE_INVOICE_NOTE,
  DELETE_INVOICE_NOTE_SUCCESS,
  INVOICE_NOTE_CLEAR_NOTIFY,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const InvoiceNote = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_NEW_INVOICE_NOTE:
    case UPDATE_INVOICE_NOTE:
    case DELETE_INVOICE_NOTE:
    case GET_INVOICE_NOTE:
      return {
        ...state,
        loading: true,
      };
    case GET_INVOICE_NOTE_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_INVOICE_NOTE_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };

    case ADD_NEW_INVOICE_NOTE_SUCCESS:
      return {
        ...state,
        message: {
          title: "Invoice Note",
          text: "Invoice Note has been added successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case UPDATE_INVOICE_NOTE_SUCCESS:
      return {
        ...state,
        message: {
          title: "Invoice Note",
          text: "Invoice Note has been updated successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case DELETE_INVOICE_NOTE_SUCCESS:
      return {
        ...state,
        message: {
          title: "Invoice Note",
          text: "Invoice Note has been deleted successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case GET_INVOICE_NOTE_FAIL:
      return {
        ...state,
        error: payload,
      };
    case INVOICE_NOTE_CLEAR_NOTIFY:
      return {
        ...state,
        message: null,
      };
    default:
      return state;
  }
};

export default InvoiceNote;
